export default __webpack_public_path__ + "static/media/arco-iris.adffaa61.png";